export interface UserForm {
  id: string; // UUID → string in frontend
  email: string;
  password: string;
  role: string;
  isVerified: boolean;
  status: string;
  createdAt: string; // ISO string (LocalDateTime → string)
  updatedAt: string;
    firstName: string;
    lastName: string
    linkedInUrl: string;
    message?: string;
    invitedByUserId: string;
    inviteCountRemaining: number;
    /**
     * Credits ever granted, off `users.invite_count_total`. Rises with admin top-ups, so it is the
     * real ceiling rather than the configured default.
     */
    inviteCountTotal: number;
    userRole:string;
}


export const initialUser: UserForm = {
  id: "",
  email: "",
  password: "",
  role: "",
  isVerified: false,
  status: "",
  createdAt: "",
  updatedAt: "",
  firstName: "",
  lastName: "",
  linkedInUrl: "",
   message: "",
    invitedByUserId: "",
    inviteCountRemaining: 0,
    inviteCountTotal: 0,
    userRole:""
};


export interface CreateUserRequest {
  email: string;
  password: string;
  role: string;
  otp: string; // Temporary field for OTP input
   firstName: string;
    lastName: string
    linkedInUrl: string;
    inviteCode:string;
    isFoundingMember2026?:boolean;
}

export interface CreateUserRequestWithEmail {
  email: string;
}

export interface RegistrationBeginRequest {
  email: string;
  referralCode?: string;
  landingPage?: string;
  inviteCode?: string;
}

export interface CompleteRegistrationRequest {
  email: string;
  password: string;
  role: string;
  firstName: string;
  lastName: string;
  linkedInUrl: string;
  inviteCode?: string;
  isFoundingMember2026: boolean;
}

export interface UserRegisterResult {
  id?: string;
  email?: string;
  role?: string;
  isVerified?: boolean;
  status?: string;
  firstName?: string;
  lastName?: string;
  message?: string;
}

export interface CreateUserRequestForRecruiterRegistration {
  recruiterEmail: string;
  password: string;
  role: string;
  recruiterFirstName: string;
  recruiterLastName: string;
}

export interface userLoginRequest {
  email: string;
  password: string;
}

export interface userLoginResponse {
  message: string;
  accessToken: string;
  tokenType: string;
  userId:string;
  role:string;
}


export interface VerifyOtpRequest {
  email: string;
  otp: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface PasswordResetResponse {
  message: string;
}